import avatar1 from "../../assets/images/avatar-1.png";
import avatar2 from "../../assets/images/avatar-2.png";
import avatar3 from "../../assets/images/avatar-3.png";
import avatar4 from "../../assets/images/avatar-4.png";
import avatar5 from "../../assets/images/avatar-5.png";
import avatar6 from "../../assets/images/avatar-6.png";
import avatar7 from "../../assets/images/avatar-7.png";
import avatar8 from "../../assets/images/avatar-8.png";
import avatar9 from "../../assets/images/avatar-9.png";
import avatar11 from "../../assets/images/avatar-11.png";
import avatar12 from "../../assets/images/avatar-12.png";
import avatar13 from "../../assets/images/avatar-13.png";
import avatar14 from "../../assets/images/avatar-14.png";
import avatar15 from "../../assets/images/avatar-15.png";
import avatar16 from "../../assets/images/avatar-16.png";

const contactdata = [
  {
    name: "Fernando Scarbrough",
    avatar: avatar1,
    email: "Fernand@armyspy.com",
    phone: "770-940-8851",
    timestamp: "Today at 09:30 AM",
    profileLink: "profile.html",
    chatLink: "chat.html",
  },
  {
    name: "Robert Vansickle",
    avatar: avatar2,
    email: "Vansickle@armyspy.com",
    phone: "770-789-8851",
    timestamp: "Today at 04:30 AM",
    profileLink: "profile.html",
    chatLink: "chat.html",
  },
  {
    name: "Eliseo Patterson",
    avatar: avatar3,
    email: "Patterson@armyspy.com",
    phone: "897-940-8851",
    timestamp: "Today at 05:48 AM",
    profileLink: "profile.html",
    chatLink: "chat.html",
  },
  {
    name: "Roger Epling",
    avatar: avatar4,
    email: "Roger@armyspy.com",
    phone: "159-940-8851",
    timestamp: "Today at 07:38 AM",
    profileLink: "profile.html",
    chatLink: "chat.html",
  },
  {
    name: "Tommy Mendez",
    avatar: avatar5,
    email: "Mendez@armyspy.com",
    phone: "456-940-8851",
    timestamp: "Today at 09:30 PM",
    profileLink: "profile.html",
    chatLink: "chat.html",
  },
  {
    name: "Marty Brassfield",
    avatar: avatar6,
    timestamp: "Today at 11:38 AM",
    email: "Brassfield@armyspy.com",
    phone: "265-940-8851",
  },
  {
    name: "Pamela Williams",
    avatar: avatar7,
    timestamp: "Today at 7:00 PM",
    email: "Williams@armyspy.com",
    phone: "278-940-8851",
  },
  {
    name: "Thomas Perry",
    avatar: avatar8,
    timestamp: "Today at 1:30 AM",
    email: "Perry@armyspy.com",
    phone: "985-940-8851",
  },
  {
    name: "James Alverez",
    avatar: avatar9,
    timestamp: "Today at 2:30 AM",
    email: "Alverez@armyspy.com",
    phone: "123-940-8851",
  },
  {
    name: "Adrienne M. Graham",
    avatar: avatar11,
    timestamp: "Today at 8:30 AM",
    email: "Graham@armyspy.com",
    phone: "654-940-8851",
  },
  {
    name: "Natalie Pearson",
    avatar: avatar12,
    phone: "786-940-8851",
    timestamp: "Today at 10:15 AM",
    email: "Pearson@armyspy.com"
  },
  {
    name: "Derek Matthews",
    avatar: avatar13,
    phone: "459-940-8851",
    timestamp: "Today at 12:45 PM",
    email: "Matthews@armyspy.com"
  },
  {
    name: "Cynthia Harper",
    avatar: avatar14,
    phone: "395-940-8851",
    timestamp: "Today at 03:00 PM",
    email: "Harper@armyspy.com"
  },
  {
    name: "Evan Wright",
    avatar: avatar15,
    phone: "213-940-8851",
    timestamp: "Today at 05:20 PM",
    email: "Wright@armyspy.com"
  },
  {
    name: "Monica Reed",
    avatar: avatar16,
    phone: "879-940-8851",
    timestamp: "Today at 06:50 PM",
    email: "Reed@armyspy.com"
  }
];

export { contactdata };
